/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Header, Footer, Loading, Snackbar } from '../../../components/index'
import { HiOutlineTrash } from 'react-icons/hi'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import { WebApi } from '../../../api/web'
import { NumberWithCommas } from '../../../utilities/generator'
import { Errors } from '../../../utilities/error'

const Cart = () => {
  const [products, setProducts] = useState(null)
  const [request, setRequest] = useState(false)
  const [existProductPhysical, setExistProductPhysical] = useState(false)
  const [tyepSends, setTypesend] = useState(null)
  const [typeSendId, setTypeSendId] = useState(null)
  const [provinces, setProvinces] = useState([])
  const [cities, setCities] = useState([])
  const [loading, setLoading] = useState(false)
  const [totalPrice, setTotalPrice] = useState(0)
  const [totalPrice2, setTotalPrice2] = useState(0)
  const [typePrice, setTypePrice] = useState(0)

  const [inputs, setInputs] = useState({
    mobile: null,
    city: null,
    province: null,
    postcode: null,
    address: null,
  })

  const handleInputs = (e) => {
    if (e.target.files) {
      const name = e.target.name
      const val = e.target.files[0]
      setInputs((prev) => {
        return {
          ...prev,
          [name]: val,
        }
      })
    } else {
      const name = e.target.name
      const val = e.target.value
      setInputs((prev) => {
        return {
          ...prev,
          [name]: val,
        }
      })
    }
  }

  useEffect(() => {
    getProducts()
  }, [request])

  useEffect(() => {
    Provinces()
    TypeSends()
    Profile()
  }, [])
  const Profile = async () => {
    setLoading(true)
    await WebApi.profile()
      .then((res) => {
        setInputs({
          address: res.data.data.user.address,
          city: res.data.data.user.city && res.data.data.user.city._id,
          province:
            res.data.data.user.province && res.data.data.user.province._id,
          mobile: res.data.data.user.mobile,
          postcode: res.data.data.user.postcode,
        })
        chooseCityProfile(res.data.data.user.province._id)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  const chooseCityProfile = async (id) => {
    await WebApi.cities(id)
      .then((res) => {
        setCities(res.data.data.cities)
      })
      .catch((err) => console.log(err))
  }
  const TypeSends = async () => {
    await WebApi.sends()
      .then((res) => {
        setTypesend(res.data.data.sends)
      })
      .catch((err) => {})
  }

  const getProducts = async () => {
    let totalPriceProducts = 0
    setExistProductPhysical(false)
    await WebApi.basket()
      .then((res) => {
        setProducts(res.data.data.basket)
        for (let i = 0; i < res.data.data.basket.length; i++) {
          if (!res.data.data.basket[i].product.isDownloadable) {
            setExistProductPhysical(true)
          }
          totalPriceProducts +=
            res.data.data.basket[i].count *
            res.data.data.basket[i].product.finalPrice
        }
        setTotalPrice(totalPriceProducts)
        setTotalPrice2(totalPriceProducts)
      })
      .catch((err) => {})
  }

  const DeleteProduct = async (id) => {
    setLoading(true)
    await WebApi.basketRemove(id)
      .then((res) => {
        setRequest(!request)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  const OrderShopDownload = async () => {
    setLoading(true)
    await WebApi.orderShopDownload(inputs.mobile)
      .then((res) => {
        window.location.href = res.data.data.orderDownloadable.url
        setLoading(false)
      })
      .catch((err) => {
        Snackbar({
          title: 'نا موفق',
          message: Errors[err.response.data.errors[0].message],
          type: 'danger',
        })
        setLoading(false)
      })
  }

  const OrderShop = async () => {
    if (typeSendId) {
      setLoading(true)
      await WebApi.orderShop(inputs, typeSendId)
        .then((res) => {
          window.location.href = res.data.data.order.url
          setLoading(false)
        })
        .catch((err) => {
          Snackbar({
            title: 'نا موفق',
            message: Errors[err.response.data.errors[0].message],
            type: 'danger',
          })
          setLoading(false)
        })
    } else {
      Snackbar({
        message: 'نحوه ارسال محصول را انتخاب کنید',
        type: 'warning',
      })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (existProductPhysical) {
      if (
        inputs.address &&
        inputs.mobile &&
        inputs.postcode &&
        inputs.province &&
        inputs.city
      ) {
        OrderShop()
      } else {
        Snackbar({
          title: 'خطا',
          message: 'کابر گرامی پر کردن تمامی فیلد هااجباری هست',
          type: 'warning',
        })
      }
    } else {
      OrderShopDownload()
    }
  }
  const Provinces = async () => {
    setLoading(true)
    await WebApi.provinces()
      .then((res) => {
        setProvinces(res.data.data.provinces)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  useEffect(() => {
    selectProvinces()
  }, [inputs.province])

  const selectProvinces = async () => {
    setLoading(true)
    await WebApi.cities(inputs.province)
      .then((res) => {
        setCities(res.data.data.cities)
        setLoading(false)
      })
      .catch((err) => setLoading(false))
  }
  const UpdateCart = async (product, key) => {
    if (product.count > 1) {
      setLoading(true)
      await WebApi.addCart(
        product.product._id,
        key == 'plus' ? product.count + 1 : product.count - 1
      )
        .then((res) => {
          setLoading(false)
          setRequest(!request)
        })
        .catch((err) => {
          setLoading(false)
          Snackbar({
            title: 'نا موفق',
            message: Errors[err.response.data.errors[0].message],
            type: 'danger',
          })
        })
    } else {
      if (key == 'plus') {
        setLoading(true)
        await WebApi.addCart(product.product._id, product.count + 1)
          .then((res) => {
            setLoading(false)
            setRequest(!request)
          })
          .catch((err) => {
            setLoading(false)
            Snackbar({
              title: 'نا موفق',
              message: Errors[err.response.data.errors[0].message],
              type: 'danger',
            })
          })
      }
    }
  }
  const settingTypeSend = (value) => {
    setTypeSendId(value._id)
    if (totalPrice2 < value.free) {
      setTypePrice(value.price)
    } else {
      setTypePrice(0)
    }
  }
  return (
    <>
      <Header title='سبد خرید' />
      {loading && <Loading />}
      <div className='container'>
        <div className='template-pages'>
          {products && tyepSends ? (
            <>
              {products.map((product) => (
                <div className='cart-product'>
                  <Row className='align-items-center'>
                    <Col xs={12} sm={9}>
                      <div className='d-flex align-items-center'>
                        <div className='img-product'>
                          <img
                            src={product.product.image}
                            alt={product.product.title}
                          />
                        </div>
                        <div className='detail-product'>
                          <h5>{product.product.title}</h5>
                          <p>
                            {product.product.category.title
                              ? product.product.category.title
                              : ''}
                          </p>
                          <div className='price'>
                            <span className='amount'>
                              {NumberWithCommas(
                                product.product.finalPrice * product.count
                              )}
                            </span>
                            <span>تومان</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={3}>
                      <div className='delete-product-cart-parent'>
                        {!product.product.isDownloadable && (
                          <div className='choose-count-product cart'>
                            <div className='setting cart'>
                              <span
                                className='item'
                                onClick={() => UpdateCart(product, 'plus')}
                              >
                                <AiOutlinePlus />
                              </span>
                              <span>{product.count}</span>
                              <span
                                className='item'
                                onClick={() => UpdateCart(product, 'minus')}
                              >
                                <AiOutlineMinus />
                              </span>
                            </div>
                          </div>
                        )}
                        <div
                          className='delete-product-cart'
                          onClick={() => DeleteProduct(product.product._id)}
                        >
                          <HiOutlineTrash size={25} />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}

              {products.length > 0 ? (
                <form onSubmit={handleSubmit}>
                  {existProductPhysical && (
                    <>
                      <Row>
                        <Col md={6}>
                          <div className='input-cart'>
                            <span>موبایل</span>
                            <input
                              type='text'
                              name='mobile'
                              value={inputs['mobile']}
                              onChange={(e) => handleInputs(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className='input-cart'>
                            <span>کد پستی</span>
                            <input
                              type='text'
                              name='postcode'
                              value={inputs['postcode']}
                              onChange={(e) => handleInputs(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className='input-cart'>
                            <span>استان</span>
                            <select
                              type='text'
                              name='province'
                              value={inputs['province']}
                              onChange={(e) => handleInputs(e)}
                            >
                              <option value='' disabled selected></option>
                              {provinces.map((province) => (
                                <option value={province._id}>
                                  {province.title}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className='input-cart'>
                            <span>شهر</span>
                            <select
                              type='text'
                              name='city'
                              value={inputs['city']}
                              onChange={(e) => handleInputs(e)}
                            >
                              <option value='' disabled selected></option>
                              {cities.map((city) => (
                                <option value={city._id}>{city.title}</option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className='input-cart'>
                            <span>نشانی دقیق</span>
                            <input
                              type='text'
                              name='address'
                              value={inputs['address']}
                              onChange={(e) => handleInputs(e)}
                            />
                          </div>
                        </Col>
                        {/* <Col md={12}>
                      <div className='input-cart'>
                        <span>آدرس ایمیل</span>
                        <input
                          type='email'
                          name='email'
                          value={inputs["email"]}
                          onChange={(e) => handleInputs(e)}
                        />
                      </div>
                    </Col> */}
                      </Row>
                      <div className='type-send'>
                        <Row>
                          {tyepSends.map((tyepSend) => (
                            <Col md={4}>
                              <div
                                className={`item ${
                                  tyepSend._id == typeSendId ? 'active' : ''
                                }`}
                                onClick={() => settingTypeSend(tyepSend)}
                              >
                                <div className='item1'>
                                  <img
                                    src={tyepSend.icon}
                                    alt={tyepSend.title}
                                  />
                                  <div className='pr-2'>
                                    <span>{tyepSend.title}</span>
                                    {totalPrice2 < tyepSend.free && (
                                      <div className='price'>
                                        <span>
                                          {NumberWithCommas(tyepSend.price)}
                                        </span>
                                        <span>تومان</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </>
                  )}
                  <div className='box-price'>
                    <span>قیمت : </span>
                    <span className='amount'>
                      {NumberWithCommas(totalPrice + typePrice)}
                    </span>
                    <span>تومان</span>
                  </div>
                  <button className='btn-click box-shadow'>
                    فاکتور را پرداخت کنید
                  </button>
                </form>
              ) : (
                <h5 className='empty-alert'>سبد خرید شما خالی هست!</h5>
              )}
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Cart
